import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  Input,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { TranslatedError } from '@x/common/error';

@Component({
  selector: 'x-shop-error-operation',
  templateUrl: './shop-error-operation.component.html',
  styleUrls: ['./shop-error-operation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'x-shop-error-operation' },
})
export class ShopErrorOperationComponent implements AfterViewInit {
  @Input() error: TranslatedError;

  @Input() needhelp: boolean = true;

  @ViewChild('bottomSheetTemplate', { read: TemplateRef }) bottomSheetTemplate: TemplateRef<any>;

  constructor(private _bottomSheet: MatBottomSheet) {}

  ngAfterViewInit(): void {
    if (this.error) {
      this._bottomSheet.open(this.bottomSheetTemplate, {
        panelClass: 'bottom-sheet-error',
        closeOnNavigation: true,
      });
    }
  }

  closeBottomSheet() {
    this._bottomSheet.dismiss();
  }
}
